<!-- Template -->

<template>
    <Layout :hospitals="hospitals" :loading="loading" :path="path"/>
</template>

<!-- Script -->

<script>
import { HospitalService } from "@/services/hospital-service";

import Layout from "@/layouts/Default";

export default {
    name: "Hospitals",

    components: {
        Layout
    },

    data() {
        return {
            hospitals: [],
            loading: true,
            path:[]
        };
    },

    created() {
        this.hospitalService = new HospitalService(this.$api, this.$store);
    },

    async mounted() {
        this.hospitals = await this.hospitalService.list();
        this.loading = false;
    }
};
</script>